document.addEventListener('DOMContentLoaded', function () {
  function initLatestBlogSlider() {
    if (typeof window.jQuery === 'undefined' || typeof window.jQuery.fn.slick === 'undefined') return;

    var $ = window.jQuery;

    $('.custom-latest-blog').each(function () {
      var $section = $(this);
      var $slider = $section.find('.custom-latest-blog__slider');
      var $progress = $section.find('.custom-latest-blog__progress span');
      var $prev = $section.find('.custom-blog-prev');
      var $next = $section.find('.custom-blog-next');

      if (!$slider.length || $slider.hasClass('slick-initialized')) return;

      function updateProgress(event, slick, currentSlide) {
        var current = (currentSlide || 0) + 1;
        var totalSteps = slick.slideCount - slick.options.slidesToShow + 1;

        if (totalSteps < 1) totalSteps = 1;

        var progress = (current / totalSteps) * 100;
        if (progress > 100) progress = 100;

        $progress.css('width', progress + '%');
      }

      $slider.on('init reInit afterChange', updateProgress);

      $slider.slick({
        slidesToShow: 3,
        slidesToScroll: 1,
        arrows: true,
        dots: false,
        infinite: false,
        speed: 350,
        prevArrow: $prev,
        nextArrow: $next,
        responsive: [
          {
            breakpoint: 990,
            settings: {
              slidesToShow: 2
            }
          },
          {
            breakpoint: 750,
            settings: {
              slidesToShow: 1
            }
          }
        ]
      });
    });
  }

  initLatestBlogSlider();

  document.addEventListener('shopify:section:load', function () {
    initLatestBlogSlider();
  });
});